(() => {
  const initialiseFooterDrawers = () => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const drawers = Array.from(document.querySelectorAll('[data-footer-menu-drawer]'));

    const closeAllDrawers = () => {
      drawers.forEach((drawer) => drawer.removeAttribute('open'));
    };

    // WCF-037 desktop footer always expanded
    const openAllDrawers = () => {
      drawers.forEach((drawer) => drawer.setAttribute('open', ''));
    };

    const syncDrawerState = (isMobile) => {
      if (isMobile) closeAllDrawers();
      else openAllDrawers();
    };

    syncDrawerState(mobileQuery.matches);

    drawers.forEach((drawer) => {
      drawer.classList.add('footer-menu-drawer--ready');
      const summary = drawer.querySelector('summary');
      summary?.addEventListener('click', (event) => {
        if (!mobileQuery.matches) event.preventDefault();
      });

      drawer.addEventListener('toggle', () => {
        if (!mobileQuery.matches) {
          if (!drawer.open) drawer.setAttribute('open', '');
          return;
        }
        if (!drawer.open) return;

        drawers.forEach((otherDrawer) => {
          if (otherDrawer !== drawer && otherDrawer.open) otherDrawer.removeAttribute('open');
        });
      });
    });

    mobileQuery.addEventListener('change', (event) => {
      syncDrawerState(event.matches);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseFooterDrawers, { once: true });
  } else {
    initialiseFooterDrawers();
  }
})();